(function() {
	'use strict';

	angular
		.module('diplomaApp') 
		.controller('editorController', ['$scope', '$http', '$location', '$log', '$filter', '$timeout', 'dpText', 'dpHelper', editorController]);

	function editorController($scope, $http, $location, $log, $filter, $timeout, dpText, dpHelper) {
		$scope.formData = {
			upload_binding_enabled: 0
		};
		$scope.bindingImageCss = 'none';
		$scope.minCount = 1;
		$scope.removeBinding = removeBinding;
		$scope.isDisabledTextLines = false;

		function initialize() {
			$http.post('/diplomovky/fast_ajax/getEditorData')
				.then(initializeSuccess);
		}

		function initializeSuccess(response) {
			$scope.sessionData = response.data.sessionData;
			$scope.isOperator = response.data.sessionData.is_operator;
			setDefaults($scope.sessionData);
			$scope.editOnly = response.data.sessionData.edit_only == 1;
			$scope.sessionId = response.data.sessionData.session_id;
			$scope.bindingFile = response.data.sessionData.binding_file;
			$scope.timestamp = (new Date()).getTime();

			$scope.dpHelper = dpHelper;
			$scope.voucher = dpHelper.getVoucherData($scope.sessionData);
			$scope.minCount = dpHelper.getMinimumCount($scope.voucher, $scope.minCount);

			$scope.bindingColors = response.data.bindingColors;
			parseBindingColors($scope.bindingColors);

			$scope.bindingFontColors = response.data.bindingFontColors;
			
			$scope.bindingBackColors = response.data.bindingBackColors;
			parseBindingColors($scope.bindingBackColors);

			$scope.txt = response.data.texts;	
			dpText.set($scope.txt); 
			dpHelper.step = response.data.step;

			if ($scope.formData.upload_binding_enabled === 1) {
				setTimeout(function () {
					angular.element('.svg-editor-container').contents().find(".insert-textblock-front").attr('disabled', 'disabled');
					angular.element('.svg-editor-container').contents().find('body').addClass('enabled_binding');
				}, 1000);
			}

			$timeout(function(){
				initUpload('#upload-binding-button', $scope.sessionId);
				$scope.$watch('formData.count', refreshPriceDataWatch);
				$scope.$watch('formData.logos_count', refreshPriceDataWatch);
				$scope.$watch('formData.text_lines_count', refreshPriceDataWatch);
				$scope.$watch('formData.upload_binding_enabled', uploadBindingEnabledWatch);
			});

			$scope.$watch('formData.binding_color_id', bindingColorWatch);
			$scope.$watch('formData.binding_back_color_id', bindingBackColorWatch);
			$scope.$watch('formData.binding_font_color_id', bindingFontColorWatch);

			function refreshPriceDataWatch(newVal, oldVal) {
				if (typeof newVal !== 'undefined' && newVal !== oldVal) {
					dpHelper.refreshPriceData($scope.formData);
				}
			}

			function uploadBindingEnabledWatch(newVal, oldVal) {
				if (newVal === 1) {
					const moduleData = $('.svg-editor-container')[0].contentWindow.moduleData;
					const svg = $('.svg-editor-container')[0].contentWindow.svg;

					angular.element('.svg-editor-container').contents().find(".insert-textblock-front").attr('disabled', 'disabled');
					angular.element('.svg-editor-container').contents().find('body').addClass('enabled_binding');

                    Session.set('upload_binding_enabled', newVal);

					Session.set('svg_editor|dp_margin_mm', [20, 20, 20, 23], function () {
						svg.resetMarginArrows(function () {
							angular.element('.svg-editor-container').contents().find('.diploma-margin-arrow').css({
								'pointer-events': 'none'
							});
						});
					});

					Session.get('svg_editor|elements', function(elements) {
						angular.forEach(elements, function(element, index) {
							if (element.type != 'dpback') {
								Session.unset('svg_editor|elements|' + index);

								var element = svg.getElementByIndex(element.id).selectElement();
								element.removeElement();
							}

							svg.selected_element = null;
						});
					});

					if ($scope.sessionData.binding_file_lines > 0) {
						$scope.isDisabledTextLines = true;
					}
				} else {
					angular.element('.svg-editor-container').contents().find(".insert-textblock-front").removeAttr('disabled');
					angular.element('.svg-editor-container').contents().find('body').removeClass('enabled_binding');

					angular.element('.svg-editor-container').contents().find('.diploma-margin-arrow').css({
						'pointer-events': 'all'
					});

					// delete $scope.formData.logos_count;
					delete $scope.formData.text_lines_count;
					delete $scope.formData.binding_file_lines;

					removeBinding();
				}
			}

			function bindingFontColorWatch(newVal, oldVal) {
				if (newVal !== oldVal) {
					var globalSpace = getSvgGlobalSpace();
					var color = getItemByKeyValue('FARBA_PISMO_ID', parseInt(newVal), $scope.bindingFontColors);
					globalSpace.setDiplomaFontColor(color.FARBA_CSS);

					dpHelper.refreshPriceData($scope.formData);
				}
			}

			function bindingBackColorWatch(newVal, oldVal) {
				if (newVal !== oldVal) {
					var globalSpace = getSvgGlobalSpace();
					var color = getItemByKeyValue('ID_FARBA_OBALKY', parseInt(newVal), $scope.bindingBackColors);
					globalSpace.setDiplomaBackColor(color.OBRAZOK_CHRBAT);

					dpHelper.refreshPriceData($scope.formData);
				}
			}

			function bindingColorWatch(newVal, oldVal) {
				if (typeof newVal !== 'undefined' && newVal !== oldVal) {
					var binding = getItemByKeyValue('ID_FARBA_OBALKY', parseInt(newVal), $scope.bindingColors);

					if ($scope.formData.binding === 'unibind') {
						$scope.bindingImageCss = 'url(\'/assets/img/diplomovka/vazby/' + binding.OBRAZOK + '\')';
					} else {
						var globalSpace = getSvgGlobalSpace();
						var relativeUrl = '/assets/img/diplomovka/binding/' + $scope.formData.binding + '/' + binding.OBRAZOK.replace('png', 'jpg');

						globalSpace.setDiplomaFrontColor(relativeUrl);

						if ($scope.formData.binding === 'foilxpress') {
							globalSpace.setDiplomaBackColor(binding.OBRAZOK_CHRBAT);
						}
					}

					if ($scope.formData.binding === 'opus' && !$scope.formData.binding_back_color_id) {
						$scope.formData.binding_back_color_id = newVal;
						dpHelper.refreshSelectpicker('formData.binding_back_color_id');
					} 
						
					dpHelper.refreshPriceData($scope.formData);
				}
			}

			function parseBindingColors(colors) {
				angular.forEach(colors, function(color, index) {
					switch (color.FARBA_OBALKA_ID) {
						case 11: 
							colors[index].OBRAZOK = 'mundial_cierna.jpg'; 
							colors[index].OBRAZOK_CHRBAT = 'mundial_cierna-chrbat.jpg'; 
						break;

						case 7: 
							colors[index].OBRAZOK = 'mundial_modra.jpg'; 
							colors[index].OBRAZOK_CHRBAT = 'mundial_modra-chrbat.jpg'; 
						break;
						
						case 21: 
							colors[index].OBRAZOK = 'mundial_hneda.jpg'; 
							colors[index].OBRAZOK_CHRBAT = 'mundial_hneda-chrbat.jpg'; 
						break;
					}
				});
			}

			dpHelper.refreshSelectpickers($scope);
		}

		function setDefaults(session) {
			var defaults = {
				count: 'int',
				payment_mode: 'string',
				binding: 'string',
				binding_processing: 'string',
				binding_color_id: 'string',
				binding_back_color_id: 'string',
				binding_font_color_id: 'string',
				list_count_content: 'int',
				list_count_attach: 'int',
				paper_mode_content: 'int',
				paper_mode_attach: 'int',
				upload_binding_enabled: 'int',
				logos_count: 'int',
				text_lines_count: 'int',
				binding_file_lines: 'int'
			};

			for (var key in defaults) {
				var type = defaults[key];
				var value = session[key];

				if (typeof value === 'undefined') {
					continue;
				}
				
				if (type === 'int') {
					value = parseInt(value);
				}

				if (type === 'string') {
					value = value + "";
				}
				
				$scope.formData[key] = value;
			}
		}

		function getSvgGlobalSpace() {
			var svg = $('.svg-editor-container')[0].contentWindow.svg;

			if (svg) {
				return svg.getGlobalSpace(); 
			} else {
				return null;
			}
		}

		function initUpload(selector, sessionId) {
			
			$(selector).uploadifive({
	            uploadScript: '/diplomovky/fast_ajax/uploadFile',
	            buttonText: $scope.txt.DP_NAHRAT,
	            fileType: 'application/pdf',
	            auto: true,
	            multi: false,
	            buttonClass: 'btn btn-success col-md-6',
	            removeCompleted: true,
	            formData: {
	                session_id: sessionId,
	                title: 'titulka',
	                thumbnail: true
	            },  
	            onUpload: function() {  
	            	var html = '<div class="progress">';
	            	html += '<div class="progress-bar progress-bar-striped active progress-upload-file" role="progressbar" style="width: 0%">';
	            	html += '<span class="sr-only">45% Complete</span>';
	            	html += '</div>';
	            	html += '</div>';
	 
	            	Alert.loader(true, dpText.get('DP_VAS_SUBOR_SA_NAHRAVA') + html);
	            },
	            onUploadComplete: function(file, json_data) {
	            	var data = JSON.parse(json_data);
	            	console.log(data);

	            	$scope.$apply(function () {
            			if (data.result) {
							if (data.result.result) {
								$scope.bindingFile = data.result;
								Session.set('binding_file', data.result);
								$scope.timestamp = (new Date()).getTime();

								if (data.lines > 0) {
									Session.set('binding_file_lines', data.lines);
									$scope.formData.logos_count = data.logos;
									$scope.formData.text_lines_count = data.lines;
									$scope.isDisabledTextLines = true;
								} else {
									$scope.isDisabledTextLines = false;
									Session.unset('binding_file_lines');
									$scope.formData.logos_count = 0;
									$scope.formData.text_lines_count = 0;
								}
							} else {
								console.log('error2');
            					delete $scope.bindingFile;
								Session.unset('binding_file');
								$scope.isDisabledTextLines = false;
								Session.unset('binding_file_lines');
								$scope.formData.logos_count = 0;
								$scope.formData.text_lines_count = 0;
							}
            			} else if (data.error) {
							console.log('error');
							Alert.alert(data.error);
						} else {
							console.log('error2');
            				delete $scope.bindingFile;
							Session.unset('binding_file');
							$scope.isDisabledTextLines = false;
							Session.unset('binding_file_lines');
							$scope.formData.logos_count = 0;
							$scope.formData.text_lines_count = 0;
            			}
			        });

	            	Alert.loader(false);
	            },
	            onUploadError: function(error) {
	                console.log(error);
	            },
	            onError: function(errorType) {
	            	if (errorType == 'FORBIDDEN_FILE_TYPE') {
	            		Alert.alert(dpText.get('DP_1_UPLOAD_TXT_NEPLATNY_TYP_SUBORU'));
	            		setTimeout(function(){
	            			Alert.loader(false);
	            		}, 300);	
	            	}
	            },
				onInit: function() {
					$('.uploadifive-button').each(function(index, el) {
						var $button = $(this).find('button[title]');

						if ($button.length) {
							var title = $button.attr('title');
							$(this).attr('title', title).tipTip();
						}
					});
					$('.uploadifive-button').removeAttr('style').removeClass('uploadifive-button').addClass('module-uploadifive-button');
				},
				onProgress: function(file, e) {
		            if (e.lengthComputable) {
		                var percent = Math.round((e.loaded / e.total) * 100);

		            	$('.progress-upload-file').css('width', percent+'%');
		            	$('.progress-upload-file').html(percent+' %');

		            	if (percent == 100) {
		            		Alert.loader(false);
		            		Alert.loader(true, dpText.get('DP_POCKAJTE_KYM_SA_SPRACUJE_SUBOR'));
		            	}
		            }
		        }
	        });
		}

		function removeBinding() {
			$http.post('/diplomovky/fast_ajax/removeBinding').then(onSuccessRemoveBinding);

			function onSuccessRemoveBinding() {
				delete $scope.bindingFile;
				$scope.isDisabledTextLines = false;
				Session.unset('binding_file_lines');
				// $scope.formData.logos_count = 0;
				$scope.formData.text_lines_count = 0;
			}
		}

		function refreshSelectpicker() {
			//timeout sa spustí až po renderi viewu
			$timeout(function() {      
		    	$('select').selectpicker('refresh');
			});
		}

		angular.element(document).ready(function () {
			initialize();
	    });
	}
}());
